import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from "lucide-react";
import { cn } from "../lib/utils.js";
function Spinner({ label }) {
    return (_jsxs(_Fragment, { children: [_jsx(Loader2, { className: "h-8 w-8 animate-spin text-muted-foreground", "aria-hidden": "true" }), label ? (_jsx("p", { className: "text-muted-foreground", children: label })) : (_jsx("span", { className: "sr-only", children: "Loading..." }))] }));
}
/** Fills the viewport. For gates that render instead of the page. */
export function FullScreenLoader({ label }) {
    return (_jsx("div", { className: "flex min-h-screen flex-col items-center justify-center gap-4", role: "status", children: _jsx(Spinner, { label: label }) }));
}
/** Fills the space a page has already laid out for its content. */
export function SectionLoader({ label, className }) {
    return (_jsx("div", { className: cn("flex flex-col items-center justify-center gap-4 py-12", className), role: "status", children: _jsx(Spinner, { label: label }) }));
}
//# sourceMappingURL=loader.js.map